// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"647":"59aca05a","986":"db257d8c"}[chunkId] + ".chunk.js";
};